module.exports = __webpack_public_path__ + "components/flag/static/square/bb-ced693b2b25be4258ac13c624833a7a5.svg";